import { createSelector } from 'reselect'
import { toHslaString } from 'shared/mappers'
import Moment from 'moment'

export const getAmbassadorConfiguration = (state: RootState) => state.ambassador

export const getAmbassadorInstanceSettings = createSelector(getAmbassadorConfiguration, AmbassadorConfiguration => AmbassadorConfiguration && AmbassadorConfiguration.instanceSettings)

export const getTitleTextStyle = createSelector(getAmbassadorInstanceSettings, instanceSettings => instanceSettings && {
    textAlign: 'center',
    fontSize: `${instanceSettings.layoutSettings.titleFontSize}px`,
    color: toHslaString(instanceSettings.layoutSettings.titleColor),
    fontStyle: instanceSettings.layoutSettings.titleItalic ? 'italic' : 'normal',
    fontWeight: instanceSettings.layoutSettings.titleBold ? 'bold' : 'normal',
})

export const getSubTitleTextStyle = createSelector(getAmbassadorInstanceSettings, instanceSettings => instanceSettings && {
    textAlign: 'center',
    fontSize: `${instanceSettings.layoutSettings.subTitleFontSize}px`,
    color: toHslaString(instanceSettings.layoutSettings.subTitleColor),
    fontStyle: instanceSettings.layoutSettings.subTitleItalic ? 'italic' : 'normal',
    fontWeight: instanceSettings.layoutSettings.subTitleBold ? 'bold' : 'normal',
})

export const getProgressStyle = createSelector(getAmbassadorInstanceSettings, instanceSettings => instanceSettings && {
    backgroundColor: toHslaString(instanceSettings.layoutSettings.backgroundHeaderColor),
})

export const getDaysRemaining = (EndDate: string): string => {
    try {
        if (EndDate === null || EndDate === '') {
            return '-'
        }
        const startDateObj = Moment().second(0).millisecond(0)
        const endDateObj = Moment(EndDate).second(0).millisecond(0)
        const difference = endDateObj.diff(startDateObj, 'days')
        if (isNaN(difference)) {
            return '-'
        }
        if (difference <= 0) {
            const differenceInHours = endDateObj.diff(startDateObj, 'hours')
            if (differenceInHours <= 0) {
                const differenceInMinutes = endDateObj.diff(startDateObj, 'minutes')
                if (differenceInMinutes <= 0) {
                    return '0 Minutes'
                }
                return `${differenceInMinutes} ${differenceInMinutes > 1 ? 'Minutes' : 'Minute'}`
            }
            return `${differenceInHours} ${differenceInHours > 1 ? 'Hours' : 'Hour'}`
        }
        if (difference === 1) {
            return '1 Day'
        }
        return `${difference} Days`
    } catch (e) {
        return '-'
    }
}

export const getConvertedCurrencyValue = (value: number): string => new Intl.NumberFormat('en-US').format(value)

export const getFormatedDate = (date: string): string => {
    if (date) {
        return Moment(date).format('MMM DD')
    }
    return '--'
}

export const getPercentageFunded = (currentValue: number, goalvalue: number): number => {
    if (!currentValue || !goalvalue) {
        return 0
    }
    const percentage = Math.floor((currentValue / goalvalue) * 100)
    if (isNaN(percentage)) {
        return 0
    }
    if (percentage < 0) {
        return 0
    }
    if (percentage > 100) {
        return 100
    }
    return percentage
}

export const changeInitiativeIndex = (mode: string, currentIndex: number, totalLength: number, callback: (index: number) => void) => {
    if (mode === '-' && currentIndex > 0) {
        callback(currentIndex - 1)
        return
    }
    if (mode === '+' && (currentIndex < totalLength - 1)) {
        callback(currentIndex + 1)
        // eslint-disable-next-line no-useless-return
        return
    }
}

export const getAmbassadorDisplayEndDateTime = createSelector(getAmbassadorInstanceSettings, settings => settings && settings.displayEndDateTime && Moment(settings.displayEndDateTime))

export const getAmbassadorDisplayStartDateTime = createSelector(getAmbassadorInstanceSettings, settings => settings && Moment(settings.displayStartDateTime))

export const getShowModule = createSelector(getAmbassadorDisplayEndDateTime, getAmbassadorDisplayStartDateTime, (displayEndDateTime, displayStartDateTime) =>
    Moment().isAfter(displayStartDateTime) && (!displayEndDateTime || Moment().isBefore(displayEndDateTime)))

export const isDonateBtnDisabled = (ChallengeStartDate: string): boolean => (new Date(ChallengeStartDate).getTime()) > (new Date()).getTime()

export const showModal = createSelector(getAmbassadorConfiguration, settings => settings && settings.showModal)
